import styled from "styled-components";
export const Section = styled.section.withConfig({ displayName: "Section", componentId: "sc-1b6y2ze" }) `
    padding: 90px 0 100px;

    /* Small devices (landscape phones, 576px and up) */
    @media (min-width: 576px) {
        padding-left: calc((100% - 540px) / 2);
        padding-right: calc((100% - 540px) / 2);
    }

    /* Medium devices (tablets, 768px and up) */
    @media (min-width: 768px) {
        padding-left: calc((100% - 720px) / 2);
        padding-right: calc((100% - 720px) / 2);
    }

    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) {
        padding-left: calc((100% - 960px) / 2);
        padding-right: calc((100% - 960px) / 2);
    }

    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
        padding-left: calc((100% - 1140px) / 2);
        padding-right: calc((100% - 1140px) / 2);
    } 
`;
